import React, { useContext } from 'react'
import styled from 'styled-components'
import { LayoutContext, useUI } from '../../contexts'
import Accordion from '../shared/Accordion'
import GatsbyImage from 'gatsby-image'

const FaqDetails = ({
  title,
  image,
  firstSectionTitle,
  firstSectionAccordion,
  secondSectionTitle,
  secondSectionAccordion,
  thirdSectionTitle,
  thirdSectionAccordion,
  fourthSectionTitle,
  fourthSectionAccordion,
}) => {
  const { node_locale, currency } = useContext(LayoutContext)

  return (
    <StyledFaqDetails>
      <Col photo>
        <StyledImage fluid={image.fluid} alt={image.title} withPlaceholder />
      </Col>
      <Col>
        <Wrapper>
          <MainTitle>{title}</MainTitle>
          <Title>{firstSectionTitle}</Title>
          <StyledAccordion
            useHtml
            startClosed
            items={firstSectionAccordion.map(({ title, content }) => ({
              title,
              content,
            }))}
            accordionTrackingData={{
              currency: currency?.code,
              locale: node_locale,
              viewType: 'Faq Page',
              sectionType: 'Faq info',
            }}
          />
          <Title>{secondSectionTitle}</Title>
          <StyledAccordion
            useHtml
            startClosed
            items={secondSectionAccordion.map(({ title, content }) => ({
              title,
              content,
            }))}
            accordionTrackingData={{
              currency: currency?.code,
              locale: node_locale,
              viewType: 'Faq Page',
              sectionType: 'Faq info',
            }}
          />
          <Title>{thirdSectionTitle}</Title>
          <StyledAccordion
            useHtml
            startClosed
            items={thirdSectionAccordion.map(({ title, content }) => ({
              title,
              content,
            }))}
            accordionTrackingData={{
              currency: currency?.code,
              locale: node_locale,
              viewType: 'Faq Page',
              sectionType: 'Faq info',
            }}
          />
          <Title>{fourthSectionTitle}</Title>
          <StyledAccordion
            useHtml
            startClosed
            items={fourthSectionAccordion.map(({ title, content }) => ({
              title,
              content,
            }))}
            accordionTrackingData={{
              currency: currency?.code,
              locale: node_locale,
              viewType: 'Faq Page',
              sectionType: 'Faq info',
            }}
          />
        </Wrapper>
      </Col>
    </StyledFaqDetails>
  )
}

const StyledFaqDetails = styled.section`
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    display: flex;
    flex-direction: row-reverse;
  }
`

const Col = styled.div`
  width: 100vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    flex: 1 0 50vw;
    flex-direction: row-reverse;
    height: ${(props) => (props.photo ? '93.1vh' : 'auto')};
    position: ${(props) => (props.photo ? 'sticky' : 'relative')};
    top: ${(props) => (props.photo ? '6.9vw' : '0')};
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    display: ${(props) => (props.photo ? 'flex' : 'block')};
    flex-direction: ${(props) => (props.photo ? 'column' : 'row-reverse')};
    justify-content: ${(props) => (props.photo ? 'center' : 'flex-start')};
    height: auto;
  }
`

const Wrapper = styled.div`
  padding: ${(props) => props.theme.space.marginMobile * 3}vw
    ${(props) => props.theme.space.marginMobile * 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    padding: ${(props) => props.theme.space.marginDesktop * 6}vw
      ${(props) => props.theme.space.marginDesktop * 8}vw;
  }
`

const StyledImage = styled(GatsbyImage)`
  height: 60vw;
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    height: 100%;
  }

  @media screen and (-ms-high-contrast: active) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}),
    screen and (-ms-high-contrast: none) and (min-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    height: auto;
  }
`

const MainTitle = styled.h1`
  font-size: 10.6666666667vw;
  padding-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;
  padding-top: 0;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 6.25vw;
    padding-bottom: ${(props) => props.theme.space.marginDesktop * 8}vw;
  }
`

const Title = styled.h2`
  font-size: 6vw;
  padding-bottom: ${(props) => props.theme.space.marginMobile / 2}vw;
  padding-top: ${(props) => props.theme.space.marginMobile}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    font-size: 2.7777777778vw;
    padding-bottom: ${(props) => props.theme.space.marginDesktop * 2}vw;
    padding-top: 0;
  }
`

const StyledAccordion = styled(Accordion)`
  line-height: 1.4;
  margin-top: ${(props) => props.theme.space.marginMobile}vw;
  margin-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;

  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    max-width: 49vw;
    margin-left: auto;
    margin-right: auto;
    margin-top: 0;
    margin-bottom: ${(props) => props.theme.space.marginDesktop * 6}vw;
  }

  button {
    font-size: 3.0666666667vw;
    line-height: 1.5;
    font-family: ${(props) => props.theme.fontFamily.medium};
    position: relative;
    width: 100%;
    color: ${(props) => props.theme.colors.black};
    padding-right: ${(props) => props.theme.space.marginMobile * 2}vw;
    padding-left: 0;
    padding-top: ${(props) => props.theme.space.marginMobile}vw;
    padding-bottom: ${(props) => props.theme.space.marginMobile}vw;
    letter-spacing: 0.025em;

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      font-size: ${(props) => props.theme.fontSize.d12};
      padding-right: ${(props) => props.theme.space.marginDesktop * 4}vw;
      padding-left: 0;
      padding-top: ${(props) => props.theme.space.marginDesktop * 1.5}vw;
      padding-bottom: ${(props) => props.theme.space.marginDesktop * 1.5}vw;
    }

    &::after {
      content: '';
      border: solid black;
      border-width: 0 0.4vw 0.4vw 0;
      display: block;
      width: 0.8vw;
      height: 0.8vw;
      transform: rotate(45deg);
      position: absolute;
      right: ${(props) => props.theme.space.marginMobile}vw;
      top: 5vw;

      @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
        border-width: 0 ${(props) => props.theme.space.marginDesktop / 8}vw
          ${(props) => props.theme.space.marginDesktop / 8}vw 0;
        width: ${(props) => props.theme.space.marginDesktop / 2}vw;
        height: ${(props) => props.theme.space.marginDesktop / 2}vw;
        right: ${(props) => props.theme.space.marginDesktop}vw;
        top: 1.8vw;
      }
    }

    &.active::after {
      transform: rotate(-135deg);
    }
  }

  div {
    font-size: 3.0666666667vw;
    line-height: 4.8vw;
    padding-right: ${(props) => props.theme.space.marginMobile * 2}vw;
    padding-left: 0;
    padding-bottom: ${(props) => props.theme.space.marginMobile * 2}vw;

    a {
      color: ${(props) => props.theme.colors.blue};
    }

    @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
      font-size: ${(props) => props.theme.fontSize.d12};
      line-height: 1.8055555556vw;
      padding-right: ${(props) => props.theme.space.marginDesktop * 8}vw;
      padding-left: 0;
      padding-bottom: ${(props) => props.theme.space.marginDesktop * 4}vw;
    }
  }

  ul,
  ol {
    display: flex;
    flex-flow: column;

    &:not(ol) {
      padding-left: 2em;
      list-style: disc;
    }

    &:not(ul) {
      padding-left: 1.5em;
      list-style: numeric;
    }

    li {
      margin-top: 0.5em;
    }
  }
`

export default FaqDetails
